module.exports = {
  StartEndDateCannotEmpty: '开始日期或结束日期不能为空！',
  StartBeEarlierThanDate: '开始日期必须小于结束日期！',
  Continent: '大洲',
  Route: '航线',
  Network: '网络',
  Currency: '币种',
  ContainerType: '箱种',
  Package: '包装',
  BillOfLadingType: '提单类型',
  CargoType: '货物类型',
  TradeTerms: '贸易条款',
  TransportationTerms: '运输条款',
  FreightTerms: '运费条款',
  TradeMethod: '贸易方式',
  CustomsDeclarationMethod: '报关方式',
  AirFreightServiceItem: '空运运费服务项目',
  RelatedPort: '关联港口',
  AirWaybillSundryCharge: '空运运单杂费',
  ClientType: '客户类型',
  AppraisalCategory: '鉴定类型',
  ShippingDocumentMethod: '提单方式',
  CustomBusinessType: '自定义业务类型',
  TransitDocumentType: '流转文件类型',
  CommissionRule: '提成规则',
  RailwayLine: '铁路航线',
  ValueAddedService: '增值服务',
  BilledUnitUnit: '计费单位/单位',
  HazardousGoods: '危险品',
  CargoInformation: '货物信息',
  LiabilityReason: '判责原因',
  ClientSource: '客户来源',
  MultimodalTransportType: '综合运输类型',
  VehicleType: '车型',
  CustomEqType: '自定义箱型',
  CollaborativeBusinessType: '协作业务类型',
  Records: '条;',
  recordsImportedToTheSystem: '@records记录成功导入系统！',
  Records2: '条',
  Edit: '编辑',
  Delete: '删除',
  Disable: '停用',
  Enable: '启用',
  AreWantToDeleteRecord: '你确定要删除该记录吗?',
  Reminder: '提示',
  Confirm: '确定',
  Cancel: '取消',
  SuccessfullyDeleted: '删除成功!',
  DeletionCanceled: '已取消删除',
  DoToOverwriteExistingData: '是否覆盖现有数据',
  Overwrite: '覆盖',
  PleaseSelectDataToExport: '请选择您要导出的数据.',
  UploadedBeXlsOrFormat: '上传文件只能是 xls、xlsx格式!',
  FileSizeCannotExceed2MB: '文件大小不能大于2MB',
  ImportPleaseContactTheAdministrator: '导入失败，请联系管理员。',
  DataExistingDataInTable: '数据与表中已有数据重复！',
  SuccessfullyAdded: '添加成功',
  City: '城市',
  BusinessType: '业务类型',
  PlatformCustomerService: '平台客服',
  Code: '代码',
  Name: '名称',
  ChineseName: '中文名',
  EnglishName: '英文名',
  ChineseName2: '中文名称',
  FeeDetailsXls: '费用明细.xls',
  UnitedNationsNumberAlreadyExists: '联合国编号已经存在',
  UserCannotBeEmpty: '用户不能为空',
  Yes: '是',
  No: '否',
  MergeInProgressPleaseWait: '正在合并，请稍等',
  YouExpectedToCompleteLater: '您可以离开此界面，预计将于10分钟内完成合并，请稍后查看',
  Note: '提示',
  Success: '操作成功',
  ChineseNameCannotBeEmpty: '中文名不能为空',
  EmailFormatError: 'Email格式错误',
  ApplicableOrderRulescombinedName: '适用放单规则（组合）名称',
  OnlyCanBeSetPort: '同一目的港仅能设置一个默认指定货代理',
  UserCannotBeEmpty2: '用户不能为空!',
  DataIsIncorrectPleaseCheck: '数据不对，请核对！',
  PleaseNumberYouWantDelete: '请选择你要删除的约号！',
  PleaseSelectABranch: '请选择分公司!',
  SiteNotSelected: '站点未选择.',
  AlreadyAddedCannotAddRepeatedly: '已添加，不能重复添加！',
  AddedSuccessfully: '添加成功',
  SavedLibraryAlreadyExistsSave: '保存成功,以下敏感词词库已存在，无需保存：',
  SavedWordsHaveBeenTimes: '保存成功,以下敏感词录入多次：',
  TheHaveBeenEnteredTimes: '以下敏感词录入多次：',
  FieldName: '字段名称',
  SensitiveWords: '敏感词',
  Threshold: '敏感词阈值',
  ThresholdTip: '敏感词阈值表示敏感词的模糊位数，0代表100%匹配校验匹配。',
  EditedSuccessfully: '编辑成功',
  ChineseProductName: '中文品名',
  EnglishProductName: '英文品名',
  ShippingMarks: '唛头',
  EmailRemindertestOnly: '邮件提醒(测试专用)',
  SplitDataBecomesNewData: '拆分（老数据变新数据）',
  SplittingDataAreYouSplit: '拆分后会移除原数据，确定拆分？',
  SplitSuccessfullySplitInto: '拆分成功,已拆成',
  SensitiveWordManagement: '敏感词管理',
  CodeCannotBeEmpty: '代码不能为空.',
  EnglishNameCannotBeEmpty: '英文名不能为空.',
  ContractConfiguration: '合同配置',
  NoteTheReminderMethodIs: '>注：提醒方式为',
  ReminderConfiguration: '提醒配置：',
  ReminderRemaining: '距到期日期剩余',
  DaysBeforeTheDueDate: '天提醒',
  ReminderUser: '提醒用户：',
  ContractAdministrator: '合同管理员',
  Sales: '销售',
  ProhibitionOfCreatingBusinessConfiguration: '禁止创建业务配置：',
  ContractAbleToCreateExpiration: '合同到期后将不能再创建业务',
  SavedSuccessfully: '保存成功',
  CustomerLevel: '客户级别',
  ContractStatus: '合同状态',
  ContractType: '合同类型',
  ExtensionCycle: '顺延周期',
  Partner: '合作伙伴',
  ContractNumber: '合同编号',
  EffectiveDate: '生效日期',
  ExpirationDate: '失效日期',
  ContractAgreement: '合同协议',
  CustomerContract: '客户合同',
  SupplierContract: '供应商合同',
  OverseasAgentContract: '海外代理合同',
  OtherContracts: '其他合同',
  ContractTerms: '合同条款',
  DeferredAfterExpiration: '到期后顺延',
  N1Year: '1年',
  N2Years: '2年',
  N3Years: '3年',
  Other: '其他',
  OneClickRenewal: '一键续签',
  Close: '关闭',
  AddContract: '新增合同',
  EditContract: '编辑合同',
  RenewContract: '续签合同',
  ViewContract: '查看合同',
  Contract: '合同',
  PartnerCannotBeEmpty: '合作伙伴不能为空.',
  ContractNumberCannotBeEmpty: '合同编号不能为空.',
  EffectiveDateCannotBeEmpty: '生效日期不能为空.',
  ExpirationDateCannotBeEmpty: '失效日期不能为空.',
  ContractAgreementCannotBeEmpty: '合同协议不能为空.',
  unSupportContractCurrency: '找不到“{0}”兑换“{1}”的直接或间接汇率，请及时维护相关汇率。',
  QuickSearchContractNumber: '快捷检索:合同编号',
  LogRecord: '日志记录',
  Add: '新增',
  HintSetToExpireDays: '提示：30天内系统设为临期',
  OperationType: '操作类型',
  Operator: '操作人',
  Time: '时间',
  EditField: '编辑字段',
  OriginalValue: '原值',
  NewValue: '新值',
  AuditStatus: '审核状态',
  OperationDate: '操作日期',
  SettlementType: '结算类型',
  SettlementMethod: '结算方式',
  Limit: '额度',
  LimitCurrency: '额度币种',
  DateType: '日期类型',
  BillingCycle: '账期周期',
  WhetherToPostpone: '是否顺延',
  PostponementCycle: '顺延周期',
  WhetherChapterHasBeenUploaded: '是否已上传订舱章',
  WhetherAgreementHasBeenUploaded: '是否已上传合同协议',
  Operation: '操作',
  Renewal: '续签',
  Revoke: '撤销',
  TheAndTheOperationAllowed: '该合同已续签，禁止操作',
  DoYouNeedToUpdate: '是否需要更新',
  ContractCreator: '合同创建人',
  ContractCreationTime: '合同创建时间',
  PartnerCreator: '合作伙伴创建人',
  ContractAuditor: '合同审核人',
  ContractAuditTime: '合同审核时间',
  PleaseSelectContractRecord: '请选中合同记录.',
  ContractRecordIsEmpty: '合同记录为空.',
  ContractRevocationSuccessful: '合同撤销成功.',
  QuickSearch: '快捷检索:',
  BulkRejection: '批量拒绝',
  All: '所有',
  Unaudited: '未审核',
  Submitted: '已提交',
  Audited: '已审核',
  PleaseSelectData: '请勾选数据。',
  OnlySchemesWithAuditUnreviewed: '只能勾选审核状态为未提交的费用方案。',
  OnlySchemesWithAuditReviewed: '只能勾选审核状态为已审核的费用方案。',
  OnlySchemesWithAuditSubmitted: '只能勾选审核状态为已提交的费用方案。',
  OnlyGuaranteeWithAuditUnreviewed: '只能勾选审核状态为未提交的保函。',
  OnlyGuaranteeWithAuditReviewed: '只能勾选审核状态为已审核的保函。',
  OnlyGuaranteeWithAuditSubmitted: '只能勾选审核状态为已提交的保函。',
  GuaranteeFileIsNull: '保函文件全部为空',
  SelectGuaranteeFileIsNull: '{0} 未上传保函文件',
  CodeDuplicatedPleaseReEnter: '代码重复，请重新输入.',
  Country: '国家',
  CannotEditMultipleSchemes: '不能编辑多条方案。',
  CannotCopyMultipleSchemes: '不能复制多条方案。',
  DeletedSuccessfully: '删除成功',
  PleaseEnterTheSchemeName: '请输入方案名称',
  PleaseEnterTheStartingRow: '请输入起始行',
  PleaseTheExcelCellName: '请填写Excel单元格名称',
  PleaseEnterTheSpaceProportion: '请输入空格数量占比',
  EnglishName2: '英文名称',
  UnknownType: '类型未知',
  SeaExport: '海运出口',
  AirExport: '空运出口',
  BusinessTypeCannotBeEmpty: '业务类型不能为空.',
  OperationTypeCannotBeEmpty: '操作要求类型不能为空.',
  ContentDescriptionCannotBeEmpty: '内容描述不能为空.',
  OverseasWarehouse: '海外仓',
  PartnerInformationImport: '合作伙伴信息导入',
  PleaseSelectTemplateType: '请选择模板类型',
  PleaseSelectImportType: '请选择导入类型',
  ImportTime: '导入时间',
  SelectDate: '选择日期',
  ImportResult: '导入结果',
  PleaseSelect: '请选择',
  ImportType: '导入类型',
  ImportSuccessful: '导入成功',
  DownloadTemplate: '下载模板',
  PartnerBasicInformation: '合作伙伴基础信息',
  PartnerBillingHeaderInformation: '合作伙伴开票抬头信息',
  Download: '下载',
  ImportFile: '导入文件',
  SelectFile: '选取文件',
  ConfirmImport: '确认导入',
  ReminderPartnerBasicInformationFirst: '提醒：请先导入合作伙伴基础信息',
  Search: '查询',
  To: '至',
  ContinueImport: '继续导入',
  EnterPartnerInformation: '进入合作伙伴',
  DownloadImportResult: '下载导入结果',
  ViewFile: '查看文件',
  SerialNumber: '流水号',
  LogFile: '日志文件',
  RemarkDescription: '备注说明',
  AllSuccessful: '全部成功',
  AllFailed: '全部失败',
  PartiallySuccessfulPartiallyFailed: '部分成功，部分失败',
  TheOnlyBeXlsFormat: '上传文件只能是 xls、xlsx格式!',
  ConfirmDeletionOfTheSite: '确认删除站点?',
  TheByTheBusinessDeleted: '以下站点已被业务使用，不允许删除!',
  RailwayStation: '铁路站点',
  WhetherToOverwriteExistingData: '是否覆盖现有数据',
  PleaseDataYouWantExport: '请选择您要导出的数据.',
  FileBeLargerThan2MB: '文件大小不能大于2MB',
  Items: '条;',
  recordsImportedIntoTheSystem: '@records记录成功导入系统！',
  Items2: '条',
  PortOfLoadingPOL: '起运港（POL）',
  PortOfDischargePOD: '卸货港（POD）',
  PlaceOfDelivery: '交货地',
  ShippingCompany: '船公司',
  DestinationPortAgent: '目的港代理',
  ShippingRoute: '航线',
  DisplayRules: '显示规则',
  OperationalRequirements: '操作要求',
  PleaseEnterTheContent: '请输入内容',
  AttachmentDescription: '附件说明',
  ViewAttachment: '查看附件',
  WhetherToUseForMBL: '是否用于MBL',
  WhetherToUseForHBL: '是否用于HBL',
  AddPortRequirementsseaPort: '添加港口要求（海港）',
  PleaseARecordForEditing: '请选择一条记录进行编辑',
  EditPortRequirementsseaPort: '编辑港口要求（海港）',
  PleaseARecordForDeletion: '请选择记录进行删除',
  WhetherDeleteTheSelectedRecords: '是否对选择的记录进行删除',
  Notice: '提示',
  DeletionCancelled: '已取消删除',
  DeletionFailed: '删除失败!',
  DisplayRulesAreRequired: '显示规则必填!',
  OperationalRequirementsAreRequired: '操作要求必填!',
  SuccessfullyAddedPortRequirements: '新增港口要求成功',
  SuccessfullyModifiedPortRequirements: '修改港口要求成功',
  MarksAndNumbers: '唛头',
  IMDGCODEImport: 'IMDG CODE导入',
  PleaseUploadTxtFormatFile: '请上传txt格式文件!',
  SuccessfullyImported: '成功导入',
  Items3: '条数据',
  DangerousGoodsList: '危险品清单',
  NoteSystemReminder: '注：提醒方式为"系统提醒"，系统会在到期前2日再提醒',
  CustomerSignedRenewal: '该客户已签订{0}，可选择该客户进行续签！',
  DuplicateBaseCurrencyValueExcel: '原货币 值为\'{0}\',基准货币 值为\'{1}\' 与Excel中其他数据重复！',
  DuplicateCurrencyValue0Table: '原货币 值为\'{0}\',基准货币 值为\'{1}\' 与表中已有数据重复！',
  DoOfThe00: '是否确认撤销与‘{0}’的‘{1}’该笔合同？',
  UploadPiecesUploadFailedPieces: '上传成功:{0}个,上传失败:{1}个.',
  DoWantToDelete0: '确认要删除【{0}】吗？',
  TheValueIs0Excel: '原货币 值为\'{0}\',基准货币 值为\'{1}\' 与Excel中其他数据重复！',
  TheIs0WhichTable: '原货币 值为\'{0}\',基准货币 值为\'{1}\' 与表中已有数据重复！',
  ChargeGroup: '费用组',
  DefaultWhtRate: '默认WHT税率',
  ApplicableWhtTax: '适用WHT税',
  ApplicableWhtTaxTip: '适用于泰国WHT（代扣代缴税）退税功能，需要配合分公司设置开启该功能。',
  ExchangeRateDecimalPlaces: '汇率小数位',
  SeaAirRoutes: '海/空航线',
  AppliedSeaport: '应用海港',
  AppliedShippingCompany: '应用船公司',
  ApplicationAirport: '应用空港',
  AppliedAirlines: '应用航空公司',
  VerificationItem: '校验项',
  SensitiveWordExists: '敏感词词库已存在',
  ClearCreditExpiration: '到期后清空信控',
  SubordinateCompanyPartners: '下级公司合作伙伴',
  GpExplainTitle: 'GP说明标题',
  UncheckArApMate: '不参与AR/AP对应校验',
  UncheckArApMateTip: '勾选后，该费用项不参与“应收包括应付”的校验判断',
  ExistCustomerVendorException: '相同名称和代码的客户供应商已存在，保存成功',
  ExistCustomerCodeExcepiton: '相同名称和代码客户已存在，保存成功',
  ExistVendorCodeException: '相同名称和代码供应商已存在，保存成功',
  SyncCustomerCodeExcepiton: '同步客户编码异常，已清空客户编码',
  SyncVendorCodeException: '同步供应商编码异常，已清空供应商编码',
  mailing: '收发通',
  SyncCustomerVendorException: '同步客户和供应商编码异常，已清空客户和供应商编码',
  b2bWebsiteDisplayNotEmpty: 'B2B网站显示不能为空',
  IsItManualLaborCost: '是否手工费用',
  FreeOfArCharge: '免收',
  FreeOfApCharge: '免付',
  MergeAndDisplayToDesignatedFees: '合并展示至指定费用',
  MergeAndDisplayTips: '目前阶段，当前租户仅支持一组费用合并展示。',
  MergeAndDisplayToDesignatedFeesTips: '针对销售查询和远程订舱模块，应付费用合并展示为指定费用名称。目前阶段，仅支持设置一组合并展示费用。',
  operationTip: '本次操作确认后不可逆！！！！',
  MscService: 'MSC Service',
  PropulsionType: 'Propulsion Type',
  AircraftModel: '机型',
  UnitLoadDevice: '集装器'
}
